module.exports = __webpack_public_path__ + "img/icons B_4.7f453052.svg";